var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatisticsFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 25.246 25.284",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_521",
    "data-name": "\\u7EC4 521",
    transform: "translate(-139.754 -3311.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_247",
    "data-name": "\\u8DEF\\u5F84 247",
    d: "M149.465,3311.765h5.817a1.1,1.1,0,0,1,.7,1.183q-.016,11.458,0,22.917a1.1,1.1,0,0,1-.7,1.184h-5.817a1.1,1.1,0,0,1-.7-1.183q.017-11.458,0-22.918A1.1,1.1,0,0,1,149.465,3311.765Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_248",
    "data-name": "\\u8DEF\\u5F84 248",
    d: "M164.3,3337.049h-5.816a1.013,1.013,0,0,1-.706-1.031q.011-8,.006-16a1.443,1.443,0,0,1,.042-.389.912.912,0,0,1,.989-.646q2.526,0,5.052,0c.793,0,1.124.332,1.124,1.123q0,7.876.007,15.752A1.116,1.116,0,0,1,164.3,3337.049Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_249",
    "data-name": "\\u8DEF\\u5F84 249",
    d: "M139.754,3322.383a1.129,1.129,0,0,1,1.217-.7c1.641.022,3.284.007,4.926.008.728,0,1.065.339,1.065,1.074,0,4.376-.005,8.751.007,13.127a1.065,1.065,0,0,1-.708,1.154h-5.816a1.223,1.223,0,0,1-.691-.691Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsFilled);
export default __webpack_public_path__ + "static/media/statistics_filled.b89cb02f.svg";
export { ForwardRef as ReactComponent };